var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { getMiniCardDetailsParams } from "../../../../helpers";
import * as RenderMethods from "./RenderMethods";
var MiniEventCard = /** @class */ (function (_super) {
    __extends(MiniEventCard, _super);
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    function MiniEventCard(props) {
        var _this = _super.call(this, props) || this;
        _this.renderMarkets = RenderMethods.renderMiniMarkets;
        _this.renderCardDetails = RenderMethods.renderMiniCardDetails;
        _this.getMiniCardDetailsParams = getMiniCardDetailsParams;
        _this.cardTypeClass = "";
        _this.componentPrefix = "mini-ev-card";
        _this.buttonsHolderClass = "rj-ev-list__" + _this.componentPrefix + "__buttons-holder";
        return _this;
    }
    MiniEventCard.prototype.setClasses = function () {
        var isSelected = this.props.event.isSelected
            ? "rj-ev-list__" + this.componentPrefix + "--selected"
            : "";
        var inKickOff = this.props.event.isInKickOffState
            ? "rj-ev-list__" + this.componentPrefix + "--in-kick-off"
            : "";
        var hideGameState = this.props.hideGameState
            ? "rj-ev-list__" + this.componentPrefix + "--game-state-hidden"
            : "";
        return "rj-ev-list__" + this.componentPrefix + " " + this.cardTypeClass + " " + isSelected + " " + inKickOff + " " + hideGameState;
    };
    MiniEventCard.prototype.render = function () {
        return (React.createElement("div", { className: this.setClasses(), "data-uat": "div-ev-list-" + this.componentPrefix },
            React.createElement("div", { className: "rj-ev-list__" + this.componentPrefix + "__inner", "data-uat": "div-ev-list-" + this.componentPrefix + "-inner" },
                this.renderCardDetails(this.getMiniCardDetailsParams(this.props), this.componentPrefix),
                this.props.showOddBtns && this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix))));
    };
    MiniEventCard = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], MiniEventCard);
    return MiniEventCard;
}(React.Component));
export { MiniEventCard };
//# sourceMappingURL=MiniEventCard.js.map